import { Badge } from "@/components/ui/badge";
import { ESTADO_LABEL } from "@/lib/format";

const STYLES = {
  comprometido: "bg-amber-100 text-amber-800 border-amber-200",
  ejecutado: "bg-sky-100 text-sky-800 border-sky-200",
  revelado: "bg-emerald-100 text-emerald-800 border-emerald-200",
};

export const StatusBadge = ({ estado, testId }) => (
  <Badge
    variant="outline"
    className={`font-medium ${STYLES[estado] || ""}`}
    data-testid={testId}
  >
    {ESTADO_LABEL[estado] || estado}
  </Badge>
);
